import { arrayOf, bool, func, number, object, string } from 'prop-types';
import React, { PureComponent } from 'react';
import classnames from 'classnames';

import Card from '../../Card/Card';
import CommonErrorBoundary from '../../Util/CommonErrorBoundary';
import LoadingIndicator from '../../LoadingIndicator/LoadingIndicator';
import RangeChart from '../../RangeChart/RangeChart';

import SeeMore from './SeeMore';
import { formatCurrencyIntl } from '../../lib/formatters';
import './jobMatchCard.scss';

export default class JobMatchCard extends PureComponent {
  static propTypes = {
    // TODO: do we need this whole object?
    app: object,
    cardClassName: string,
    className: string,
    currentMatch: bool,
    highVariance: bool,
    feature: string,
    jobCurrency: string,
    jobTasks: string,
    jobTitle: string,
    loadingDetails: bool,
    matchId: string,
    onMouseEnter: func,
    onMouseLeave: func,
    onSelectMatchClick: func,
    payRange: arrayOf(number),
    payRangeScaleMax: number,
    payRangeScaleMin: number,
    rangeChartWidth: number,
    topMatch: bool
  };

  static defaultProps = { rangeChartWidth: 220 };

  constructor(props) {
    super(props);

    this.state = { selected: props.currentMatch };
    this.bottomLabelFormatter = this.bottomLabelFormatter.bind(this);
    this.selectMatchClick = this.selectMatchClick.bind(this);
  }

  // allow new props to override state
  // it would have been better to not move currentMatch props to selected state but not worth a refactor
  componentDidUpdate(prevProps) {
    const { currentMatch } = this.props;

    if (currentMatch !== prevProps.currentMatch) {
      this.setState({ selected: currentMatch });
    }
  }

  bottomLabelFormatter(val, index) {
    const { app, jobCurrency } = this.props;

    if (index === 1) return '';

    const intl = {
      currency: jobCurrency,
      display: 'symbol',
      preferHourlyRate: false,
      useHourly: false,
      useThousands: true
    };

    return formatCurrencyIntl(val, intl, app);
  }

  selectMatchClick() {
    const { onSelectMatchClick } = this.props;
    const { selected } = this.state;

    this.setState({ selected: !selected });
    onSelectMatchClick(selected);
  }

  render() {
    const {
      cardClassName,
      className,
      currentMatch,
      highVariance,
      feature,
      jobTasks,
      jobTitle,
      loadingDetails,
      matchId,
      onMouseEnter,
      onMouseLeave,
      payRange,
      payRangeScaleMax,
      payRangeScaleMin,
      rangeChartWidth,
      topMatch,
      isMP
    } = this.props;
    const { selected } = this.state;
    const cardClass = classnames(
      {
        [cardClassName]: cardClassName,
        [className]: className,
        'match-card__top-match': (topMatch && !isMP) || (selected && isMP && feature === 'crowd_source_match')
      },
      'job__match-card'
    );
    const currentMatchClass = classnames({
      'current-match__mp': isMP && feature === 'crowd_source_match',
      'current-match': !isMP
    });
    const topMatchClass = classnames(
      {
        'top-match__mp': isMP && feature === 'crowd_source_match'
      },
      'top-match'
    );
    const showCurrentMatch = (
      <div className={currentMatchClass}>
        <i className="current-match icon-check" />{' '}
        {`${isMP && feature === 'crowd_source_match' ? 'Current' : 'Your'} Match`}
      </div>
    );
    const showTopMatch = (
      <div className={topMatchClass}>
        {feature !== 'crowd_source_match' && <i className="top-match icon-check" />} Top Match
      </div>
    );

    return (
      <CommonErrorBoundary>
        <Card
          className={cardClass}
          onCardClick={feature !== 'crowd_source_match' ? this.selectMatchClick : null}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          raiseOnHover={false}
          topMatch={topMatch}
        >
          <div className="job__match-card-content--small">
            <div className="job__match-card-header">
              <div className="job__match-card-top">
                <img className="job__match-card-logo" src="/view/static/mp/images/payScale-logo.png" />
                <div className="pull-right card__indicator">
                  {topMatch && showTopMatch}
                  {selected && !isMP && showCurrentMatch}
                </div>
              </div>
              <div className="job__match-card-title">{jobTitle}</div>
            </div>
            <div className="job__match-card-tasks">
              <div className="job__match-card-tasks-text">
                <SeeMore maxChar={isMP ? 250 : 422}>{jobTasks}</SeeMore>
              </div>
            </div>
            <div className="job__match-card-pay">
              {loadingDetails && (
                <div className="job__match-card-loading">
                  <LoadingIndicator loading={loadingDetails} />
                </div>
              )}
              {!loadingDetails && payRange?.length > 0 && (
                <RangeChart
                  alwaysShowLabels={true}
                  barHeight={20}
                  bottomLabelFormatter={this.bottomLabelFormatter}
                  className="job__match-range"
                  colors={['#22d6dd', '#a7eff1']}
                  data={payRange}
                  hasLine={!highVariance}
                  height={25}
                  hideTopLabels
                  highVariance={highVariance}
                  id={`match${matchId}-market-range`}
                  invertLabels={false}
                  labelFontSize={11}
                  labelTextAnchor={['start', 'middle', 'end']}
                  labelToBarSpacingTop={5}
                  labelsVisible={true}
                  scaleMax={payRangeScaleMax}
                  scaleMin={payRangeScaleMin}
                  width={rangeChartWidth}
                />
              )}
            </div>
            {!loadingDetails && (!payRange || payRange.includes(undefined)) && (
              <div className="job__match-card-no-data">
                <i className="icon-warning" />
                No salary data available
              </div>
            )}
            {!selected && isMP && feature === 'crowd_source_match' && (
              <button className="pxl-btn add-match__button" onClick={this.selectMatchClick}>
                Add This Match
              </button>
            )}
            {selected && isMP && feature === 'crowd_source_match' && showCurrentMatch}
          </div>
        </Card>
      </CommonErrorBoundary>
    );
  }
}
